<template>
   <b-modal size="xl" id="bv-modal-whatsnew" 
      @ok="this.emitEventOK" scrollable centered :title="$t('Layout.QuickHelp')"
      :no-close-on-esc="true" 
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      @shown="onShown"
      :cancel-title="$t('Shared.BtnCancel')"
     >
     
    <Loading v-bind:IsLoading="this.Loading" />
    <div class="whatsnew">
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="0"
        controls
        indicators
        background="linear-gradient(#52EAFF,#0272B7)"
        img-width="1024"
        img-height="480"
        style="text-shadow: 2px 2px 4px #000;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
        @slid="onSlideChange"
      >
        <!-- WELCOME -->
        <b-carousel-slide img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['welcome.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{ Name }}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen.WTxt1')}} <span class="bullet">{{$t('whatsnew.wScreen.WTxt2')}}</span>, {{$t('whatsnew.wScreen.WTxt3')}} <span class="bullet">{{$t('Shared.Close')}}</span> {{$t('whatsnew.wScreen.WTxt5')}} <span class="bullet">{{$t('whatsnew.wScreen.WTxt6')}}</span> {{$t('whatsnew.wScreen.WTxt7')}}</p>
        </div></b-carousel-slide>
        <!-- MENU TOGGLE -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['toggle_menu.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen1.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen1.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen1.WTxt3')}}</span> {{$t('whatsnew.wScreen1.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen1.WTxt5')}}</span> {{$t('whatsnew.wScreen1.WTxt6')}}</p>
        </div></b-carousel-slide>
        <!-- WHERE TO START -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['mainmenu.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen2.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen2.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen2.WTxt3')}}</span>, {{$t('whatsnew.wScreen2.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen2.WTxt5')}}</span>, {{$t('whatsnew.wScreen2.WTxt6')}}</p>
        </div></b-carousel-slide>
        <!-- OPTIONS MENU -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['optionsmenu.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen3.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen3.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen3.WTxt3')}}</span> {{$t('whatsnew.wScreen3.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen3.WTxt5')}}</span>. {{$t('whatsnew.wScreen3.WTxt6')}} <span class="bullet">{{$t('whatsnew.wScreen3.WTxt7')}}</span> {{$t('whatsnew.wScreen3.WTxt8')}} <span class="bullet">{{$t('whatsnew.wScreen3.WTxt9')}}</span> {{$t('whatsnew.wScreen3.WTxt10')}}</p>
        </div></b-carousel-slide>
        <!-- LISTING -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['listing.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen4.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen4.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen4.WTxt3')}}</span> {{$t('whatsnew.wScreen4.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen4.WTxt5')}}</span> {{$t('whatsnew.wScreen4.WTxt6')}} <span class="bullet">{{$t('whatsnew.wScreen4.WTxt7')}}</span> {{$t('whatsnew.wScreen4.WTxt8')}}</p>
        </div></b-carousel-slide>
        <!-- DASHBOARDS -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['dashboards.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen5.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen5.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen5.WTxt3')}}</span> {{$t('whatsnew.wScreen5.WTxt4')}}</p>
        </div></b-carousel-slide>
        <!-- SAVING -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['saving.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen6.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen6.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen6.WTxt3')}}</span> {{$t('whatsnew.wScreen6.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen6.WTxt5')}}</span> {{$t('whatsnew.wScreen6.WTxt6')}} <span class="bullet">{{ $t('Shared.Save') }}</span> {{$t('whatsnew.wScreen6.WTxt7')}}</p>
        </div></b-carousel-slide>
        <!-- NOTES PANELS -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['notes.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen7.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen7.WTxt2')}} <span class="bullet">{{$t('Shared.ClinicalNotes')}}</span> {{$t('whatsnew.wScreen7.WTxt3')}} <span class="bullet">{{$t('whatsnew.wScreen7.WTxt4')}}</span> {{$t('whatsnew.wScreen7.WTxt5')}} <span class="bullet">{{$t('whatsnew.wScreen7.WTxt6')}}</span>. {{$t('whatsnew.wScreen7.WTxt7')}}</p>
        </div></b-carousel-slide>
        <!-- NOTES SCROLLING -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['notesscrolling.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen8.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen8.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen8.WTxt3')}}</span> {{$t('whatsnew.wScreen8.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen8.WTxt5')}}</span>, {{$t('whatsnew.wScreen8.WTxt6')}}</p>
        </div></b-carousel-slide>
        <!-- NOTES SAVING -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="this.imagesMap['savingnotes.png'][this.locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen9.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen9.WTxt2')}} <span class="bullet">{{$tc('Shared.ActionsTxt',2)}}</span> {{$t('whatsnew.wScreen9.WTxt21')}} <span class="bullet">{{$t('Shared.Save')}}</span> {{$t('whatsnew.wScreen9.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen9.WTxt5')}}</span>. {{$t('whatsnew.wScreen9.WTxt6')}} <span class="bullet">{{$t('Shared.Close')}}</span> {{$t('whatsnew.wScreen9.WTxt7')}}</p>
        </div></b-carousel-slide>      
        {{$t('whatsnew.wScreen10.WTxt1').toUpperCase()}} 
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['notesattachments.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen10.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen10.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen10.WTxt3')}}</span> {{$t('whatsnew.wScreen10.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen10.WTxt5')}}</span> {{$t('whatsnew.wScreen10.WTxt6')}} <span class="bullet">{{$t('whatsnew.wScreen10.WTxt7')}}</span> {{$t('whatsnew.wScreen10.WTxt8')}} <span class="bullet">{{$t('Shared.Save')}}</span> {{$t('whatsnew.wScreen10.WTxt9')}}</p>
        </div></b-carousel-slide>
        <!-- DATE TIME -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['datetime.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen11.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen11.WTxt2')}} <span class="bullet">{{$t('whatsnew.wScreen11.WTxt3')}}</span> {{$t('whatsnew.wScreen11.WTxt4')}} <span class="bullet">{{$t('whatsnew.wScreen11.WTxt5')}}</span> {{$t('whatsnew.wScreen11.WTxt6')}} <span class="bullet">{{$t('whatsnew.wScreen11.WTxt7')}}</span> {{$t('whatsnew.wScreen11.WTxt8')}} <span class="bullet">{{$t('whatsnew.wScreen11.WTxt9')}}</span> {{$t('whatsnew.wScreen11.WTxt10')}}</p>
        </div></b-carousel-slide>
        <!-- LOGOUT -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['logout.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{$t('whatsnew.wScreen12.WTxt1')}}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen12.WTxt2')}} <span class="bullet">{{$t('Layout.Start')}}</span> {{$t('whatsnew.wScreen12.WTxt3')}} <span class="bullet">{{$t('Shared.Logout')}}</span> {{$t('whatsnew.wScreen12.WTxt4')}}</p>
        </div></b-carousel-slide>
        <!-- REPLAY HELP -->
        <b-carousel-slide  img-blank img-alt=""><div>
        <b-img class="img-frame" :src="imagesMap['replay.png'][locale]" fluid-grow></b-img></div><div class="mx-3"><h4>
          {{ Name }}</h4><p class="text-justify">
          {{$t('whatsnew.wScreen13.WTxt1')}}<sup>®</sup> {{$t('whatsnew.wScreen13.WTxt2')}} <span class="bullet">{{$t('Layout.QuickHelp')}}</span> {{$t('whatsnew.wScreen13.WTxt3')}} <span class="bullet">{{$t('Layout.Start')}}</span> {{$t('whatsnew.wScreen13.WTxt4')}}</p>
        </div></b-carousel-slide>

      </b-carousel>
    </div>
    <div slot="modal-footer">
      <b-row>
        <b-col style="align-self: center">
          <b-form-checkbox
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
        >{{$t('whatsnew.dShowAgain')}}</b-form-checkbox>
        </b-col>
        <b-col style="text-align: end;"><b-btn id="whatsnew_btn_close" variant="primary" @click="addUpdQhStatus" >{{$t('Shared.Close')}}</b-btn></b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

import StorageService from '@/services/storage.service'
import Utils from '../../../common/utils';
import Loading from '@/components/template/loading/Loading'
import Quickhelp from '@/services/quickhelp.service'
import ShowMessage from '@/components/messages/ShowMessage.js'

import toggleMenuEn from '../../../assets/images/whatsnew/toggle_menu.png';
import toggleMenuEs from '../../../assets/images/whatsnew/toggle_menu-es.png';
import toggleMenuAr from '../../../assets/images/whatsnew/toggle_menu-ar.png';
import mainMenuEn from '../../../assets/images/whatsnew/mainmenu.png';
import mainMenuEs from '../../../assets/images/whatsnew/mainmenu-es.png';
import mainMenuAr from '../../../assets/images/whatsnew/mainmenu-ar.png';
import optionsMenuEn from '../../../assets/images/whatsnew/optionsmenu.png';
import optionsMenuEs from '../../../assets/images/whatsnew/optionsmenu-es.png';
import optionsMenuAr from '../../../assets/images/whatsnew/optionsmenu-ar.png';
import welcomeMenuEn from '../../../assets/images/whatsnew/welcome.png';
import welcomeMenuEs from '../../../assets/images/whatsnew/welcome-es.png';
import welcomeMenuAr from '../../../assets/images/whatsnew/welcome-ar.png';
import dashboardsMenuEn from '../../../assets/images/whatsnew/dashboards.png';
import dashboardsMenuEs from '../../../assets/images/whatsnew/dashboards-es.png';
import dashboardsMenuAr from '../../../assets/images/whatsnew/dashboards-ar.png';
import datetimeMenuEn from '../../../assets/images/whatsnew/datetime.png';
import datetimeMenuEs from '../../../assets/images/whatsnew/datetime-es.png';
import datetimeMenuAr from '../../../assets/images/whatsnew/datetime-ar.png';
import listingMenuEn from '../../../assets/images/whatsnew/listing.png';
import listingMenuEs from '../../../assets/images/whatsnew/listing-es.png';
import listingMenuAr from '../../../assets/images/whatsnew/listing-ar.png';
import logoutMenuEn from '../../../assets/images/whatsnew/logout.png';
import logoutMenuEs from '../../../assets/images/whatsnew/logout-es.png';
import logoutMenuAr from '../../../assets/images/whatsnew/logout-ar.png';
import notesMenuEn from '../../../assets/images/whatsnew/notes.png';
import notesMenuEs from '../../../assets/images/whatsnew/notes-es.png';
import notesMenuAr from '../../../assets/images/whatsnew/notes-ar.png';
import notesattachmentsMenuEn from '../../../assets/images/whatsnew/notesattachments.png';
import notesattachmentsMenuEs from '../../../assets/images/whatsnew/notesattachments-es.png';
import notesattachmentsMenuAr from '../../../assets/images/whatsnew/notesattachments-ar.png';
import notesscrollingMenuEn from '../../../assets/images/whatsnew/notesscrolling.png';
import notesscrollingMenuEs from '../../../assets/images/whatsnew/notesscrolling-es.png';
import notesscrollingMenuAr from '../../../assets/images/whatsnew/notesscrolling-ar.png';
import replayMenuEn from '../../../assets/images/whatsnew/replay.png';
import replayMenuEs from '../../../assets/images/whatsnew/replay-es.png';
import replayMenuAr from '../../../assets/images/whatsnew/replay-ar.png';
import savingMenuEn from '../../../assets/images/whatsnew/saving.png';
import savingMenuEs from '../../../assets/images/whatsnew/saving-es.png';
import savingMenuAr from '../../../assets/images/whatsnew/saving-ar.png';
import savingnotesMenuEn from '../../../assets/images/whatsnew/savingnotes.png';
import savingnotesMenuEs from '../../../assets/images/whatsnew/savingnotes-es.png';
import savingnotesMenuAr from '../../../assets/images/whatsnew/savingnotes-ar.png';

export default {
  components: { 
    Loading
  },
  name: 'WhatsNew',
  mixins: [ShowMessage],  
  data() {
      return {  
        Loading:false,
        status:false,
        loadstatus:false,
        slide: 0,
        Name:'',
        sliding: null,
        qHelpReferenceList :[],
        quickHelpObj:{
            userId: '',
            doNotShowQuickHelp : false,
        },
        imagePath: '../../../assets/images/whatsnew/',
        imagesMap: {
            'toggle_menu.png': { 'en': toggleMenuEn, 'es': toggleMenuEs, 'ar': toggleMenuAr },
            'mainmenu.png': { 'en': mainMenuEn,'es': mainMenuEs, 'ar': mainMenuAr },
            'optionsmenu.png': {'en': optionsMenuEn, 'es': optionsMenuEs, 'ar': optionsMenuAr },
            'welcome.png': { 'en': welcomeMenuEn, 'es': welcomeMenuEs, 'ar': welcomeMenuAr },
            'dashboards.png': { 'en': dashboardsMenuEn, 'es': dashboardsMenuEs, 'ar': dashboardsMenuAr },
            'datetime.png': { 'en': datetimeMenuEn,'es': datetimeMenuEs, 'ar': datetimeMenuAr },
            'listing.png': { 'en': listingMenuEn, 'es': listingMenuEs, 'ar': listingMenuAr },
            'logout.png': { 'en': logoutMenuEn,'es': logoutMenuEs, 'ar': logoutMenuAr },
            'notes.png': {'en': notesMenuEn, 'es': notesMenuEs, 'ar': notesMenuAr },
            'notesattachments.png': { 'en': notesattachmentsMenuEn,  'es': notesattachmentsMenuEs ,'ar': notesattachmentsMenuAr },
            'notesscrolling.png': { 'en': notesscrollingMenuEn, 'es': notesscrollingMenuEs,'ar': notesscrollingMenuAr},
            'replay.png': { 'en': replayMenuEn,'es': replayMenuEs, 'ar': replayMenuAr},
            'saving.png': { 'en': savingMenuEn, 'es': savingMenuEs, 'ar': savingMenuAr},
            'savingnotes.png': { 'en': savingnotesMenuEn,'es': savingnotesMenuEs, 'ar': savingnotesMenuAr}
        },
        locale: localStorage.language        
      }
  },
  methods: {
    getName(){
      this.Name = Utils.strToTitleCase(StorageService.getName());
    },

    emitEventOK(evt){
      // Prevent modal from closing    
      evt.preventDefault();
      // Trigger changeStatus handler
      this.changeStatus(evt)
    },

    statusToBoolean: function(string){
      switch(string){
          case "true": case true: return true;
          case "false": case false:  case null: return false;
          default: return Boolean(string);
      }
    },

    addUpdQhStatus() {
      if (this.statusToBoolean(this.status) != this.loadstatus){
        this.getUserQhReference(false);
        if(this.qHelpReferenceList.length == 0) {
          this.addUserQhReference();
        } else {
          this.updUserQhReference();
        }
      }
      this.$bvModal.hide('bv-modal-whatsnew');
    },
 
    getUserQhReference(flag){
      const userid = StorageService.getUserId();
      Quickhelp.getQhUserPreference(userid)
        .then((response) => { 
          if(response.data && response.data.length > 0){
            this.qHelpReferenceList = response.data;
            if(flag) {
                this.status = response.data[0].doNotShowQuickHelp
                this.loadstatus = response.data[0].doNotShowQuickHelp
            }
          }     
        })
        .catch(error => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          } 
        });  
    },

    addUserQhReference(){
      this.quickHelpObj.userId = StorageService.getUserId();
      this.quickHelpObj.doNotShowQuickHelp = this.statusToBoolean(this.status);

      Quickhelp.addQhUserPreference(this.quickHelpObj)
        .then((response) => { 
          console.log(response)
        })
        .catch(error => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          } 
        });  
    },

    updUserQhReference(){
      const userId = StorageService.getUserId();
      const localQuickHelpObj  = {
        doNotShowQuickHelp :this.statusToBoolean(this.status)
      }

      Quickhelp.updateQhUserPreference(userId, localQuickHelpObj)
        .then((response) => { 
          console.log(response)
        })
        .catch(error => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          } 
        });  
    },

    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    onShown(){
      this.getUserQhReference(true);
    },
    onSlideChange() {

      window.scrollTo(0, 0); // Scroll al principio de la página
    }
  },
  mounted() {
      this.getName();
     
  }
}
</script>
<style>
#bv-modal-whatsnew___BV_modal_body_{
  padding: 0;
}
.modal-footer {
  padding: 5px 10px !important;
}
.modal-footer>div{
  width: 100%;
}
.whatsnew .carousel-caption{
  right: 7%;
  left: 7%;
  top: 10px;
}
.whatsnew .carousel-control-prev, .whatsnew .carousel-control-next{
  width: 7%;
}
.whatsnew .carousel-control-next, .flashing-arrow{
 animation: fadeinout 1s linear infinite;
}
@keyframes fadeinout {
  0%,100% { opacity: 0; }
  50% { opacity: 1; }
}
.whatsnew .img-frame{
    border: 7px solid #FFF;
    border-radius: 20px;
    margin-bottom: 20px;
}
@media screen and (max-width: 768px) {
  .whatsnew .img-frame{
    margin-bottom: 54px;
  }
}
.whatsnew h4{
  text-transform: capitalize;
  background: linear-gradient(90deg, #00000000, #00000077, #00000000 );
  margin:0;
  padding: 8px 0;
}
.whatsnew p{
  font-size: 1em;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  border-top: 1px solid #FFF;
  padding: 10px 10px 0 10px;
}
.modal-footer .custom-checkbox label{
  padding-top: 3px;
}
.bullet{
  background-color: #00000022;
  padding: 0 6px;
  border-radius: 6px;
}
@media screen and (max-width: 768px) {
  .carousel-inner{
    height: 450px !important;
  }
  .whatsnew h4{
    text-transform: capitalize;
    background-color:#00000077;
    padding: 2px 0;
  }
  .whatsnew .mx-3{
    margin: 0 5px !important;
  }
}
</style>